import LatLngPoint from "./latlngpoint"

export default class SearchResultModel {
    constructor(
        region: string,
        subregion: string,
        municipality: string,
        placeType: string,
        label: string,
        coordinates: LatLngPoint) {
            this.region = region
            this.subregion = subregion
            this.municipality = municipality
            this.placeType = placeType
            this.label = label
            this.coordinates = coordinates
        }

    region: string
    subregion: string
    municipality: string
    placeType: string
    label: string
    coordinates: LatLngPoint

    toJsonObject(): any {
        return {
            region: this.region,
            subregion: this.subregion,
            municipality: this.municipality,
            placeType: this.placeType,
            label: this.label,
            coordinates: this.coordinates
        }
    }

    getFullName(): string {
        let fullName: string = this.label
        if (this.municipality?.length > 0) {
            fullName += ", " + this.municipality
        }
        if (this.placeType?.length > 0) {
            fullName += ", " + this.placeType
        }
        return fullName
    }

    getShortName(): string {
        return this.getStreetAddress() + ", " + this.municipality
    }

    getStreetAddress(): string {
        return this.label.split(" (")[0]
    }
}
